import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiInstagram, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { FaTiktok } from 'react-icons/fa';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="UstaConsulting" className="logo-image" />
            </Link>
            <p className="footer-desc">
              {t('footer.desc')}
            </p>
            <div className="footer-social">
              <a href="https://www.instagram.com/ustaconsulting" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FiInstagram />
              </a>
              <a href="https://www.tiktok.com/@ustaconsulting" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <FaTiktok />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/services">{t('nav.services')}</Link></li>
              <li><Link to="/packages">{t('nav.packages')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/blog">{t('nav.blog')}</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>{t('footer.services')}</h4>
            <ul>
              <li><Link to="/services">{t('footer.socialMedia')}</Link></li>
              <li><Link to="/services">{t('footer.ecommerce')}</Link></li>
              <li><Link to="/services">{t('footer.adProduction')}</Link></li>
              <li><Link to="/services">{t('footer.modelOptions')}</Link></li>
              <li><Link to="/services">{t('footer.digitalConsulting')}</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>{t('contact.info')}</h4>
            <ul>
              <li>
                <FiMapPin />
                <span>İlkbahar Mah. Sinpaş Altınoran Sitesi Kule 3 No: 196, Çankaya/Ankara</span>
              </li>
              <li>
                <FiPhone />
                <a href="tel:+905337757181">+90 (533) 775 71 81</a>
              </li>
              <li>
                <FiMail />
                <a href="mailto:info@ustaconsulting.com">info@ustaconsulting.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} UstaConsulting. {t('footer.rights')}</p>
          <div className="footer-legal">
            <Link to="/privacy">{t('footer.privacy')}</Link>
            <Link to="/terms">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
